export default "__VITE_ASSET__Rl0ueqxl__"